<template>
  <div class="detail-page">
    <!-- 学员服务说明特殊页面 -->
    <template v-if="isServicePage">
      <div class="service-back-nav" @click="$router.push({ name: 'News' })">
        <img class="back-icon" src="../../images/notice/back.png" alt="" />
        <span class="back-text">返回</span>
      </div>
      <CourseActivation v-if="serviceId === 'serviceDescription'" />
      <FeedbackGuide v-else-if="serviceId === 'feedbackInstructions'" />
      <RetakeGuide v-else-if="serviceId === 'rightsProtection'" />
      <RefundGuide v-else-if="serviceId === 'refundPolicy'" />
    </template>

    <!-- 普通资讯详情 -->
    <template v-else>
      <div class="notice-head">
        <div class="back-nav" @click="$router.push({ name: 'News' })">
          <img class="back-icon" src="../../images/notice/back.png" alt="" />
          <span class="back-text">返回</span>
        </div>
        <div class="notice-layout">
          <h1 class="notice-title">{{ detail.name }}</h1>
          <h4 class="notice-subtitle">{{ detail.summary || detail.subtitle }}</h4>
          <div class="notice-meta">
            <span class="notice-date">{{ formatTime(detail.createTime) }}</span><br/>
            <a v-if="detail.annex" :href="detail.annex" target="_blank" class="notice-download">{{ detail.file_name || '下载资料' }}</a>
          </div>
        </div>
      </div>
      <div class="notice-body ql-editor" v-html="detail.brief"></div>
      <div v-if="relatedList.length > 0" class="related-section">
        <h3 class="related-title">推荐阅读</h3>
        <div class="related-list">
          <a v-for="item in relatedList" :key="item.id" class="related-card" @click.prevent="goDetail(item)">
            <h4 class="related-card-title">{{ item.name }}</h4>
            <p class="related-card-desc">{{ item.subtitle }}</p>
            <span class="related-card-link">查看详情 &gt;</span>
          </a>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import CourseActivation from "../../components/service/CourseActivation.vue";
import FeedbackGuide from "../../components/service/FeedbackGuide.vue";
import RefundGuide from "../../components/service/RefundGuide.vue";
import RetakeGuide from "../../components/service/RetakeGuide.vue";

const INFO_API = "https://old.qbbystudy.com/api/old_qbby/notice/info";
const LIST_API = "https://old.qbbystudy.com/api/old_qbby/notice/list";
const SERVICE_IDS = ["serviceDescription", "feedbackInstructions", "rightsProtection", "refundPolicy"];

export default {
  name: "NewsShow",
  components: { CourseActivation, FeedbackGuide, RefundGuide, RetakeGuide },
  data() {
    return {
      detail: {},
      relatedList: [],
      loading: false,
      scrollTop: 0,
    };
  },
  computed: {
    serviceId() {
      return this.$route.params.id;
    },
    isServicePage() {
      return SERVICE_IDS.includes(this.serviceId);
    },
  },
  watch: {
    "$route.params.id": {
      handler(id) {
        if (id && !SERVICE_IDS.includes(id)) this.fetchDetail();
      },
    },
  },
  async created() {
    if (!this.isServicePage) await this.fetchDetail();
  },
  activated() {
    window.scrollTo(0, this.scrollTop);
  },
  beforeRouteLeave(_to, _from, next) {
    this.scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
    next();
  },
  methods: {
    async fetchDetail() {
      const id = this.$route.params.id;
      if (!id) return;

      this.loading = true;
      try {
        const res = await this.$http.get(INFO_API, { id }, { showLoading: false, skipApiError: true });
        const data = res.data || res;
        const detail = data.detail || data || {};
        // info API: 顶层 data.tags 是名称数组，detail.tags 是 ID 数组
        detail.tags = data.tags || detail.tags || [];
        this.detail = detail;
        await this.fetchRelated();
      } catch (e) {
        console.error("获取资讯详情失败:", e);
        this.detail = {};
      } finally {
        this.loading = false;
      }
    },

    async fetchRelated() {
      try {
        const params = { pageNo: 1, pageSize: 6 };
        const res = await this.$http.get(LIST_API, params, { showLoading: false, skipApiError: true });
        const payload = res.data || res;
        const list = (payload.list || payload.data || []).filter(
          item => item.id !== this.detail.id
        );
        this.relatedList = list.slice(0, 5);
      } catch (e) {
        console.error("获取推荐列表失败:", e);
        this.relatedList = [];
      }
    },

    goDetail(item) {
      this.$router.push({ name: "NewsShow", params: { id: item.id } });
      window.scrollTo(0, 0);
    },

    formatTime(ts) {
      if (!ts) return "-- -- --";
      const d = new Date(ts);
      const y = d.getFullYear();
      const m = String(d.getMonth() + 1).padStart(2, "0");
      const day = String(d.getDate()).padStart(2, "0");
      return `${y}-${m}-${day}`;
    },
  },
};
</script>

<style lang="scss" scoped>
.detail-page {
  padding-bottom: 60px;
}

// 服务页返回
.service-back-nav {
  display: inline-flex;
  align-items: center;
  cursor: pointer;
  padding: 4px 0 12px;

  .back-icon {
    width: 9px;
    margin-right: 6px;
  }

  .back-text {
    font-size: 18px;
    font-weight: 500;
    color: #121212;
  }
}

// ====== 顶部头图区域 ======
.notice-head {
  position: relative;
  padding: 20px 10px 36px;
  border-bottom: 1px solid #f0f1f5;
  height: 450px;
  background-image: url("https://kaoyan-prod.oss-cn-beijing.aliyuncs.com/uploads/2026/06/02/6a1e77f77b72c.png");
  background-size: 100%;
  background-position: center -120px;
  background-repeat: no-repeat;
  box-sizing: border-box;
}

// 返回按钮
.back-nav {
  display: inline-flex;
  align-items: center;
  cursor: pointer;

  .back-icon {
    width: 9px;
    margin-right: 6px;
  }

  .back-text {
    font-size: 18px;
    font-weight: 500;
    color: #121212;
  }
}

.notice-layout {
  margin-top: 20px;
  max-width: 600px;
}

.notice-title {
  font-size: 28px;
  font-weight: 600;
  color: #121212;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  text-overflow: ellipsis;
  margin: 0 0 12px 0;
  line-height: 1.4;
}

.notice-subtitle {
  font-size: 16px;
  font-weight: 500;
  color: #999;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 4;
  overflow: hidden;
  text-overflow: ellipsis;
  margin: 0;
  line-height: 1.6;
}

.notice-meta {
  // margin-top: 16px;
}

.notice-date {
  font-size: 15px;
  font-weight: 400;
  color: #999;
  margin-bottom: 8px;
}

.notice-download {
  display: inline-block;
  color: #dc2c32;
  border-bottom: 1px solid #dc2c32;
  font-size: 14px;
  text-decoration: none;
  cursor: pointer;

  &:hover {
    opacity: 0.8;
  }
}

// ====== 正文 ======
.notice-body {
  margin: 20px 0;
  min-height: 300px;

  /deep/ {
    .el-loading-mask {
      background-color: transparent;
    }
    font-size: 15px;
    color: #333;
    line-height: 1.8;

    h1, h2, h3 {
      color: #121212;
    }

    h2 {
      font-size: 18px;
      margin: 32px 0 16px;
    }

    h3 {
      font-size: 16px;
      margin: 24px 0 12px;
    }

    p {
      margin: 0 0 16px;
      font-size: 15px;
      line-height: 1.8;
    }

    blockquote {
      margin: 0 0 20px;
      padding: 12px 20px;
      background: #f7f8fa;
      border-left: 4px solid #dc2c32;
      color: #666;
      font-size: 14px;
      line-height: 1.8;

      p { margin: 0; }
    }

    ul, ol {
      padding-left: 24px;
      margin-bottom: 16px;

      li { margin-bottom: 8px; }
    }

    table {
      width: 100% !important;
      max-width: 100%;
      border-collapse: collapse;
      margin: 16px 0 24px;
      font-size: 14px;

      td, th {
        border: 1px solid #e8e8e8;
        padding: 10px 14px;
        text-align: left;
      }

      td:first-child {
        font-weight: 600;
        background: #fafafa;
        white-space: nowrap;
      }
    }

    img {
      max-width: 100%;
      height: auto;
      margin: 16px auto;
    }

    a {
      color: #236fa1;
      text-decoration: underline;
    }
  }
}

// ====== 推荐阅读 ======
.related-section {
  margin-top: 40px;
  padding: 24px 28px;
  background: #fff;
  border-radius: 12px;
  border: 1px solid #ead7d8;
}

.related-title {
  margin: 0 0 16px;
  font-size: 18px;
  font-weight: 600;
  color: #61030d;
  padding-bottom: 12px;
  border-bottom: 1px solid #ead7d8;
}

.related-list {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px;
}

.related-card {
  display: block;
  padding: 20px 24px;
  background: #fbf8f5;
  border: 1px solid #ead7d8;
  border-radius: 10px;
  text-decoration: none;
  transition: all 0.2s;
  cursor: pointer;

  &:hover {
    border-color: #8c0b18;
    background: #fbf1f2;
  }
}

.related-card-title {
  margin: 0 0 8px;
  font-size: 16px;
  font-weight: 600;
  color: #121212;
}

.related-card-desc {
  margin: 0 0 10px;
  font-size: 14px;
  color: #6d6062;
  line-height: 1.6;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.related-card-link {
  font-size: 14px;
  color: #8c0b18;
}

@media screen and (max-width: 1440px) {
  .notice-head {
    height: auto;
    padding-bottom: 30px;
    background-size: cover;
    background-position: center top;
  }
  .notice-layout { max-width: 500px; }
  .related-list { grid-template-columns: 1fr 1fr; }
}
</style>
